export default __webpack_public_path__ + "static/media/Leonardo Piccione vincitore.1fb751bc.jpg";